<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="w-6 h-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="
        M4 7
        c1.1 0 2-.9 2-2
        h12
        c0 1.1.9 2 2 2
        v10
        c-1.1 0-2 .9-2 2
        H6
        c0-1.1-.9-2-2-2
        V7z
      "
    />

    <path
      stroke-linecap="round"
      stroke-width="2"
      stroke-dasharray="2 2"
      d="M12 9v6"
    />
  </svg>
</template>

<script>
export default {
  name: "VoucherIcon"
}
</script>

<style scoped>
svg {
  display: block;
  color: currentColor;
}
</style>
